export const getStyles = (theme, { variant } = {}) => {
  const isInline = variant === 'inline';

  return {
    // Label always sits on its own line above the value(s).
    container: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: '4px',
    },
    label: {
      fontSize: '10px',
      fontWeight: '700',
      color: theme.palette.color.grayMain,
    },
    values: {
      display: 'flex',
      flexDirection: isInline ? 'row' : 'column',
      alignItems: isInline ? 'baseline' : 'flex-start',
      flexWrap: isInline ? 'wrap' : 'nowrap',
      gap: '4px',
    },
    time: {
      fontSize: '10px',
      color: theme.palette.color.black,
    },
  };
};
